<template>

  <div>
    <div style="width: 100%;">
      <img src="../../productAndService/banner_01.png" alt="产品与服务" style="width: 100%; height: auto;">
    </div>

    <!-- 头部切换 -->
    <div class="wd100 pdtop" style="width: 1255px;margin: 40px auto;position: relative;z-index: 199;">
      <div class="breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item"><a @click="active('/')">首页></a></li>
            <li class="breadcrumb-item"><a href="#">产品与服务></a></li>
            <li class="breadcrumb-item">知识产权</li>
          </ol>
        </nav>
      </div>
      <div class="navigation">
        <div class="navigation-title">知识产权</div>
        <div class="navigation-links">
          <a href="#" class="navigation-link" :class="{ active: activeLink === 'patent' }"
             @click.prevent="selectLink('patent')">专利申请与转让</a>
          <span class="separator">|</span>
          <a href="#" class="navigation-link" :class="{ active: activeLink === 'trademark'  }"
             @click.prevent="selectLink('trademark')">商标注册与转让</a>
          <span class="separator">|</span>
          <a href="#" class="navigation-link" :class="{ active: activeLink === 'copyright' }"
             @click.prevent="selectLink('copyright')">版权登记与转让</a>
          <!--          <span class="separator">|</span>-->
          <!--          <a href="#" class="navigation-link" :class="{ active: activeLink === 'software' }" @click.prevent="selectLink('software')">计算机软件著作权</a>-->
        </div>
      </div>
    </div>


    <!--专利申请start******************************************************************************************************************************************************************************-->
    <div v-show="patentShow">
      <div class="wd100 pdtop" style="width: 1255px;margin: 10px auto; height: 252px;">
        <div class="content-section" style="height: 225px">
          <div class="content-box">
            <div class="content-box-title">发明专利</div>
            <img src="./zhuanli01.png" alt="发明专利"/>
          </div>
          <div class="content-box border" style="width: 128px;height: 159px;padding-top: 15px;">
            <ul>
              <li>商标转让介绍</li>
              <li>申请所需资料</li>
              <li>所需时间</li>
              <li>所需费用</li>
              <li>办理流程</li>
              <li>安贝森优势</li>
            </ul>
          </div>

          <div class="content-box">
            <div class="content-box-title">实用性新型专利</div>
            <img src="./zhuanli02.png" alt="实用性新型专利"/>
          </div>

          <div class="content-box">
            <div class="content-box-title">外观专利</div>
            <img src="./zhuanli03.png" alt="外观专利"/>
          </div>
          <div class="content-box">
            <div class="content-box-title">PCT国际申请</div>
            <img src="./zhuanli04.png" alt="PCT国际申请"/>
          </div>
          <div class="content-box">
            <div class="content-box-title">专利无效宣告</div>
            <img src="./zhuanli05.png" alt="专利无效宣告"/>
          </div>
          <div class="content-box">
            <div class="content-box-title">专利年费缴纳</div>
            <img src="./zhuanli06.png" alt="专利年费缴纳"/>
          </div>
        </div>
      </div>
      <div class="wd100 pdtop text-containerdiv2">
        <div>
        <span style="font-size: 24px;font-weight: 800">发明专利介绍
        <span class="spanSty">Patent application</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv3">
              <p class="pstyle2">
                &nbsp;&nbsp; &nbsp;&nbsp;发明专利是最受认可、价值最高、稳定性最强的一种技术专利，是客户委托专业机构，向国家以公
                开技术为条件换取的垄断权。结构、材料和方法的技术创新都可能获得发明专利权，其申请存在客观的
                风险，保护有地域、时间限制。发明专利的最终目的是推动社会进步。
              </p>

              <div class="icon-container">
                <div class="icon-item">
                  <img src="./zhuanli08.png" alt="避免同行侵权" class="icon-image">
                  <p class="icon-text">避免同行侵权</p>
                </div>
                <div class="icon-item">
                  <img src="./zhuanli09.png" alt="扩展市场份额" class="icon-image">
                  <p class="icon-text">扩展市场份额</p>
                </div>
                <div class="icon-item">
                  <img src="./zhuanli10.png" alt="实力资质凭证" class="icon-image">
                  <p class="icon-text">实力资质凭证</p>
                </div>
                <div class="icon-item">
                  <img src="./zhuanli11.png" alt="获得政策扶持" class="icon-image">
                  <p class="icon-text">获得政策扶持</p>
                </div>
              </div>

            </div>
          </div>
          <div class="image-container2">
            <img src="./zhuanli07.png" alt="Image Description" style="margin-top: -65px;position: absolute;">
          </div>
        </div>


        <!--申请所需资料-->
        <div style="position: absolute;margin-top:365px;width: 707px">
        <span class="titleSty">申请所需资料
        <span class="spanSty">Required information</span></span>
          <p class="pstyle3">1、基本申请资料：</p>
          <p class="pstyle2">①申请人的姓名或名称（全称）、地址、邮编;</p>
          <p class="pstyle2">②申请人的营业执照、组织机构代码证或个人身份证复印件;</p>
          <p class="pstyle2">③发明人(自然人)的姓名、地址、邮编；</p>
          <p class="pstyle2">④办理该发明专利申请的联系人的电话、传真、联系地址。</p>
        </div>

        <div style="width: 1215px;position: absolute; margin-top: 570px;">
          <p class="pstyle2">
            2、技术资料：提交一份技术交底书，为了我们更好的理解贵方的发明创造的内容，更方便的撰写发明交底书，请按照我公司提供的模板撰写交底书。</p>
          <p class="pstyle2"> 3、专利代理委托书</p>
        </div>

        <div style="position: absolute;margin-top: 668px;width: 707px">
        <span class="titleSty">所需时间
        <span class="spanSty">Required time</span></span>
          <p class="pstyle3"> 1、发明专利从申请日起，须2年左右收到专利局“授权通知书”；</p>
          <p class="pstyle2"> 2、按规定缴纳证书费后，约二至三个月，发《专利证书》；;</p>
          <p class="pstyle2"> 3、保护期限是：从申请日算起20年，20年后自动失效。</p>
        </div>

        <div style="position: absolute;margin-top: 841px;width: 707px">
        <span class="titleSty">所需费用
        <span class="spanSty">Required cost</span></span>
          <p class="pstyle3">
            1、申请费实审费登记费(请联系我司代理人获取最新报价及费用减缓信息);
          </p>
          <p class="pstyle2">
            2、专利获得授权后，按时缴纳专利年费。
          </p>
        </div>

        <div style="position: absolute;margin-top: 992px;width: 707px">
        <span class="titleSty">办理流程
        <span class="spanSty">Handling process</span></span>
          <p class="pstyle3">
            1、发明专利顺利审查流程：
          </p>
          <p class="pstyle4">
            申请 -> 初步审查 -> 符合 -> 登记公告 -> 实质审查 -> 符合 -> 发明专利授权
          </p>
          <p class="pstyle4">
            2、发明专利不顺利审查流程：
          </p>
          <p class="pstyle4">
            申请->初步审查->不符合->对驳回决定不服->请求复审->不符合->对复审决定不服的->收到通知之日三个月内->向人民法院起诉
          </p>
        </div>


        <div style="position: absolute;margin-top: 1240px;width: 707px">
        <span class="titleSty">安贝森优势
        <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList  customStyle="position: absolute;margin-top: 1280px;width: 1200px;margin-left: -25px;" />
      </div>
    </div>
    <!--专利申请end******************************************************************************************************************************************************************************-->


    <!--商标注册start*******************************************************************************************************************************************************************************-->
    <div v-show="trademarkShow">
      <div class="wd100 pdtop" style="width: 1255px;margin: 10px auto; height: 252px;">
        <div class="content-section" style="height: 225px">
          <div class="content-box">
            <div class="content-box-title">商标注册申请</div>
            <img src="./sb01.png" alt="商标注册申请"/>
          </div>
          <div class="content-box">
            <div class="content-box-title">商标复审</div>
            <img src="./sb02.png" alt="商标复审"/>
          </div>
          <div class="content-box">
            <div class="content-box-title">商标转让、变更</div>
            <img src="./sb03.png" alt="商标转让、变更"/>
          </div>
          <div class="content-box border">
            <ul>
              <li>商标转让介绍</li>
              <li>商标转让的优势</li>
              <li>知识产权商标转让合作流程</li>
              <li>商标转让所需要的材料</li>
              <li>安贝森优势</li>
            </ul>
          </div>
          <div class="content-box">
            <div class="content-box-title">商标国际注册</div>
            <img src="./sb04.png" alt="商标国际注册"/>
          </div>
        </div>
      </div>
      <div class="wd100 pdtop pdtopStyle" style="height: 2200px">
        <div>
        <span class="titleSty">商标注册及转让介绍
        <span class="spanSty">introduce</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2">
                &nbsp;&nbsp; &nbsp;&nbsp;商标注册是商标使用人取得商标专用权的前提和条件，只有经核准注册的商标，才受法律保护。商标注册原则是确定商标专用权的基本准则,不同的注册原则的选择，
                是各国立法者在这一个问题中对法律的确定性和法律的公正性二者关系进行权衡的结果。
              </p>
              <p class="pstyle2" style="margin-bottom: 10px">
                &nbsp;&nbsp; &nbsp;&nbsp;商标转让是指商标所有人在注册商标的有效期内，依法定程序，将商标权转让给另一方的行为。转
                让注册商标，应依法履行一定的手续，且必须经商标局核准后，转让注册才能生效。转让注册商标，商
                标注册人对其在同一种商品上注册的近似商标，或者在类似商品上注册的相同或者近似的商标，应当一
                并转让。转让注册商标经核准后，予以公告。受让人自公告之日起享有商标专用权。
              </p>
            </div>
          </div>
          <div class="image-container2">
            <img src="./sb05.png" alt="Image Description" style="margin-top: -65px;position: absolute;">
          </div>
        </div>

        <!--注册商标的好处-->
        <div style="position: absolute;margin-top: 288px;width: 1255px">
        <span class="titleSty">注册商标的好处
        <span class="spanSty">Benefits of registration</span></span>
          <div class="feature-container">
            <div class="feature-item">
              <img src="./sb06.png" alt="品牌保护" class="feature-icon">
              <h3 class="feature-title">品牌保护</h3>
              <p class="feature-description">防止品牌名称被他人恶意冒用，全面保护品牌。</p>
            </div>
            <div class="feature-item">
              <img src="./sb07.png" alt="无形资产" class="feature-icon">
              <h3 class="feature-title">无形资产</h3>
              <p class="feature-description">公司的无形资产，可对其价值进行评估。</p>
            </div>
            <div class="feature-item">
              <img src="./sb08.png" alt="品牌推广" class="feature-icon">
              <h3 class="feature-title">品牌推广</h3>
              <p class="feature-description">有利于推广公司品牌，建立品牌认知，便于消费者认牌购物。</p>
            </div>
            <div class="feature-item">
              <img src="./sb09.png" alt="市场通行证" class="feature-icon">
              <h3 class="feature-title">市场通行证</h3>
              <p class="feature-description">办理质检、卫检、条码等的必备条件。</p>
            </div>
            <div class="feature-item">
              <img src="./sb10.png" alt="企业信誉载体" class="feature-icon">
              <h3 class="feature-title">企业信誉载体</h3>
              <p class="feature-description">入驻各平台的通行证，开通微信品牌官方区必备条件。</p>
            </div>
          </div>
        </div>

        <!--商标转让的优势-->
        <div style="position: absolute;margin-top: 665px;width: 707px">
        <span class="titleSty">商标转让的优势
        <span class="spanSty">Trademark assignment advantage</span></span>
          <p class="pstyle3"> 1、使企业在短时间内获得自己所需商标</p>
          <p class="pstyle2">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;对于企业来说，购买商标具有绝对的时间优势。注册商标需要1年左右时间，而通过商标转让获得
            商标，时间可缩短一半，使企业能够在第一时间内拥有自己的品牌。</p>
        </div>

        <div style="width: 1215px;position: absolute; margin-top: 805px;">
          <p class="pstyle4"> 2、转让的商标风险大大降低</p>
          <p class="pstyle2">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;转让的商标本身就是已经核准的注册商标，已经得到了商标局的认定，所以不存在商标局因近似驳回商标的可能性，风险大大降低，可使企业迅速进入品牌化进程。
          </p>
          <p class="pstyle4"> 3、增加了自由选择商标的机会</p>
          <p class="pstyle2">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;目前，比较好的汉字组合大都已经被注册了，企业要想申请一个名字较好的商标非常困难。购买商标则可以选择具有自身企业含义、更符合自身发展的商标。
          </p>
          <p class="pstyle4"> 4、充分发挥商标价值</p>
          <p class="pstyle2">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;商标是一种无形资产，但在某些企业中却无法发挥出其真正价值，然而通过商标转让，其他企业可将商标的价值发挥出来。进行商标转让的双方均获得了利益，从而达到
            双赢。
          </p>
        </div>


        <div style="position: absolute;margin-top: 1080px;width: 707px">
        <span class="titleSty">商标转让合作流程
        <span class="spanSty">Collaboration process</span></span>
          <p class="pstyle3"> 1、专属顾问咨询，案件评估分析，确定最佳保护方案;</p>
          <p class="pstyle2"> 2、签订商标转让合同;</p>
          <p class="pstyle2"> 3、指导客户准备，完善相关资料文件;</p>
          <p class="pstyle2"> 4、上报提交申请材料，客户确认并递交至国家商标局；</p>
          <p class="pstyle2">
            5、案件根据，跟进受理、审查过程，并主动向客户反馈进度;</p>
          <p class="pstyle2"> 6、获得核准证明。商标局核发商标转让核准证明。</p>
        </div>

        <div style="position: absolute;margin-top: 1345px;width: 707px">
        <span class="titleSty">商标转让所需要的材料
        <span class="spanSty">Required materials</span></span>
          <p class="pstyle3">
            1、转让方与受让方的主体资格证明文件复印件(公司：加盖鲜章；个人：签字)</p>
          <p class="pstyle2">
            2、商标局规定的格式文件：申请书、委托书(需要递交原件)</p>
          <p class="pstyle2"> 3、商标证明文件复印件 (需要最新的文件)</p>
          <p class="pstyle2"> 4、公证书 (需根据商标局要求决定是否公证)</p>
          <p class="pstyle2">(备注：知识产权类案件为先付费制)</p>
        </div>


        <div style="position: absolute;margin-top: 1580px;width: 707px">
        <span class="titleSty">安贝森优势
        <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList  customStyle="position: absolute;margin-top: 1615px;width: 1200px;margin-left: -25px;" />
      </div>
    </div>
    <!--商标注册end*******************************************************************************************************************************************************************************-->


    <!--版权登记******************************************************************************************************************************************************************************-->
    <div v-show="copyrightShow">
      <div class="wd100 pdtop pdtopStyle" style="height: 1900px">
        <div>
        <span class="titleSty">版权登记与转让介绍
        <span class="spanSty">Introduce</span></span>
        </div>
        <div class="container1">
          <div class="text-container">
            <div class="text-containerdiv">
              <p class="pstyle2">
                &nbsp;&nbsp;&nbsp;&nbsp;版权登记涉及著作权法第三条所列的作品，如文字作品、口述作品、美术摄影作品、影视作品、音
                乐作品，录像作品、工程和产品设计图纸及其说明等。
              </p>
              <p class="pstyle2" style="margin-bottom: 10px">
                &nbsp;&nbsp;&nbsp;&nbsp;版权转让，版权所有者将其版权中的财产权利转让给他人享有。版权转让的方式有继承、赠与和有
                偿出让等。版权的有偿转让是版权交易的基本内容，在中国又称“卖版权”。版权转让可以是版权中部
                分财产权利的转让，也可以是版权中全部财产权利的转让；可以是在版权保护期中某一段时间内转让，
                也可以是在整个版权保护期内的转让。
              </p>
            </div>
          </div>
          <div class="image-container2">
            <img src="./bq001.png" alt="Image Description" style="margin-top: -65px;position: absolute;">
          </div>
        </div>

        <!--版权申请的好处及作用-->
        <div style="position: absolute;margin-top: 288px;width: 1255px">
        <span class="titleSty">版权申请的好处及作用
        <span class="spanSty">Benefits and functions</span></span>
          <div class="bqcontainer">
            <img src="./bq002.png" alt="背景图片" class="bqbackground-image">
            <div class="bqtext-overlay">
              <div class="bqbox">
                <p class="ph3" style="font-size: 20px;font-weight: 600;">维护作者合法权益</p>
                <p>维护作者或其他版权人和作品使用者的合法权益，</p>
                <p>有助于解决归属版权纠纷，并为解决版权纠纷提供</p>
                <p>初步证据。</p>
              </div>
              <div class="bqbox" style="padding-left: 19px">
                <p class="ph3" style="font-size: 20px;font-weight: 600;">有利于实现经济价值</p>
                <p>有利于作品、软件的许可、转让，有利于作品、软</p>
                <p>件的传播和经济价值的实现。</p>
              </div>
              <div class="bqbox" style="padding-left: 24px">
                <p class="ph3" style="font-size: 20px;font-weight: 600">个人价值企业实力的体现</p>
                <p>个人自我价值的体现，企业创新实力的表现。</p>
              </div>
            </div>
          </div>
        </div>

        <!--服务内容-->
        <div style="position: absolute;margin-top: 745px;width: 707px">
          <span class="titleSty">服务内容
          <span class="spanSty">Service content</span></span>
        </div>
        <div style="width: 1215px;position: absolute; margin-top: 805px;">
          <div class="fwcontainer">
            <div class="fwbox">
              <div class="fwheader">
                <h3>查询版权规划方案</h3>
              </div>
              <div class="fwcontent">
                <p>免费查询版权相关信息，资深专家进行版权规划，规划企业版权保护方案。</p>
              </div>
            </div>
            <div class="fwbox">
              <div class="fwheader">
                <h3>提交申请</h3>
              </div>
              <div class="fwcontent">
                <p>提交申请，项目专员提交版权登记申请。</p>
              </div>
            </div>
            <div class="fwbox">
              <div class="fwheader">
                <h3>跟踪进度解答问题</h3>
              </div>
              <div class="fwcontent">
                <p>资深顾问跟踪案件，案件进度随时可查，专业答复，针对企业疑问提供专业解答。</p>
              </div>
            </div>
          </div>
        </div>


        <!--服务流程-->
        <div style="position: absolute;margin-top: 1000px;width: 1255px">
          <span class="titleSty">服务流程
          <span class="spanSty">Collaboration process</span></span>
        </div>
        <div style="width: 1255px;position: absolute; margin-top: 1100px;">
          <div class="process-container">
            <img src="./bq003.png" alt="背景图片" class="process-background-image">

            <div class="process-text-overlay">
              <div class="process-step-1">
                <div class="process-title-vertical">材料提交</div>
                <p class="process-description" style="line-height: 2">根据清单提交登记申请材料登记机构核直接收材料</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">缴纳费用</div>
                <p class="process-description" style="line-height: 2">通知缴费，申请人缴纳登记费用</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">受理申请</div>
                <p class="process-description">登记机构受理申请，审查</p>
              </div>
              <div class="process-step-1">
                <div class="process-title-vertical">证书发放</div>
                <p class="process-description">制作发放登记证书且公告</p>
              </div>
            </div>

          </div>
        </div>

        <div style="position: absolute;margin-top: 1300px;width: 707px">
          <span class="titleSty">安贝森优势
          <span class="spanSty">Our advantage</span></span>
        </div>
        <AdvantageList  customStyle="position: absolute;margin-top: 1330px;width: 1200px;margin-left: -25px;" />

      </div>
    </div>
    <!--版权登记******************************************************************************************************************************************************************************-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height:150px">
    </div>
  </div>


</template>
<style scoped>
@import 'intellectualProperty.css';
</style>
<script>
import {save} from '@/api/common'
import AdvantageList from '../common/advantageList.vue';
export default {
  components: {AdvantageList},
  data() {
    return {
      activeLink: 'patent',
      patentShow: true,
      trademarkShow: false,
      copyrightShow: false,
      softwareShow: false,
    }
  },

  methods: {
    selectLink(link) {

      // 重置所有模块的显示状态为 false
      this.patentShow = false;
      this.trademarkShow = false;
      this.copyrightShow = false;
      this.softwareShow = false;

      // 根据点击的链接设置对应模块的显示状态为 true
      if (link === 'patent') {
        this.patentShow = true;
      } else if (link === 'trademark') {
        this.trademarkShow = true;
      } else if (link === 'copyright') {
        this.copyrightShow = true;
      } else if (link === 'software') {
        this.softwareShow = true;
      }

      this.activeLink = link; // 更新当前选中的链接

    },
  },
  mounted: function () {

  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/service/intellectualProperty/intellectualProperty.vue